import React from 'react';
import {Link} from 'react-router-dom';
import * as S from "../styles";
import { routes } from "#app/constants/routes";
import logoWS from '#app/assets/icons/logo-ws.svg';

const RoboBlockSection = ({ i18n }) => {
    return (
        <S.RoboBlock>
            <S.Wrap>
                <S.RoboBlockContent>
                    <div>
                        <img src={logoWS} alt="Logo WS" width={60} height={60}/>
                    </div>
                    <h2>{i18n.mainPage.block41}</h2>
                    <p>{i18n.mainPage.block42}</p>
                    <S.RoboButton as={Link} to={routes.ROBO}>
                        {i18n.mainPage.roboButton || 'Узнать больше'}
                    </S.RoboButton>
                </S.RoboBlockContent>
            </S.Wrap>
        </S.RoboBlock>
    );
};

export default RoboBlockSection;

